import styled, { css } from 'styled-components';

export const FlexibleDiv = styled.div`
  display: flex;
`;

export const FlexCenterAligned = styled(FlexibleDiv)`
  align-items: center;
  justify-content: center;
`;

export const FlexColumn = styled(FlexibleDiv)`
  flex-direction: column;
`;

export const FlexBetween = styled(FlexibleDiv)`
  justify-content: space-between;
  align-items: center;
`;

export const ellipsisText = css`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const multilineEllipsis = (linesToShow = 2) => css`
  display: block;
  display: -webkit-box;
  max-height: ${linesToShow * 1.2}em;
  line-height: normal;
  -webkit-line-clamp: ${linesToShow};
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const EllipsisText = styled.div`
  ${ellipsisText};
  ${({ styles }) => styles}
`;

export const AdsBlock = styled.div`
  position: absolute;
  top: 3px;
  left: 0;
  z-index: 11;
`;
export const FlexCenteredColumn = styled(FlexColumn)`
  align-items: center;
`;

export const customScrollbar = trackMargin => css`
  ::-webkit-scrollbar {
    width: 2px;
    display: flex;

    &-track {
      background: #eae5e1;
      border-radius: 10px;
      margin-bottom: ${trackMargin};
    }

    &-thumb {
      background: ${({ theme }) => theme.colors.text.secondary};
      border-radius: 10px;

      &:hover {
        background: #807c75;
      }
    }
  }
`;

export const arrow = ({
  size,
  fill,
  bw = '1px',
  angle = '-45deg',
  side = 'after',
  indent = size / 2,
  indentType = 'left'
}) => css`
  &::${side} {
    content: ' ';
    display: inline-block;
    vertical-align: middle;
    border-right: ${bw} solid ${fill};
    border-bottom: ${bw} solid ${fill};
    width: ${size};
    height: ${size};
    margin-${indentType}: ${indent};
    transform: rotate(${angle});
  }
`;

export const transitionStyles = (transition: string) => css`
  transition: ${transition} 0.3s ease;
`;

export const fillFlatNewIconWithColor = (color: string) => css`
  svg path:nth-of-type(1) {
    ${transitionStyles('fill')}
    fill: ${color};
  }

  svg path:nth-of-type(4),
  svg path:nth-of-type(5),
  svg path:nth-of-type(8) {
    ${transitionStyles('stroke')}
    stroke: ${color};
  }

  svg rect {
    ${transitionStyles('fill')}
    fill: ${color};
  }
`;

export const fillVillaIconWithColor = (color: string) => css`
  svg path:not(:nth-of-type(5)) {
    ${transitionStyles('stroke')}
    stroke: ${color};
  }

  svg rect:first-of-type {
    ${transitionStyles('fill')}
    fill: ${color};
  }

  svg rect:last-of-type {
    ${transitionStyles('stroke')}
    stroke: ${color};
  }
`;

export const AdaptiveColumnContainer = styled.div`
  display: grid;
  grid-auto-flow: row;
  grid-template-columns: 1fr;
  grid-auto-columns: 1fr;
  align-items: center;

  ${({ $mobCountOfRows }) =>
    $mobCountOfRows &&
    css`
      grid-template-rows: repeat(${$mobCountOfRows}, auto);
      grid-auto-flow: column;
      grid-auto-rows: auto;
    `};

  @media screen and (min-width: ${({ theme }) => theme.tabletBreakpoint}) {
    ${({ $tabletCountOfRows }) => css`
      grid-template-rows: repeat(${$tabletCountOfRows || 3}, auto);
    `}
    grid-auto-flow: column;
    grid-auto-rows: auto;
    grid-template-columns: unset;
  }

  @media screen and (min-width: ${({ theme }) => theme.desktopBreakpoint}) {
    ${({ $deskCountOfRows }) => css`
      grid-template-rows: repeat(${$deskCountOfRows || 2}, auto);
    `}
  }
`;

export const imagePreviewStyles = css`
  position: relative;
  background-color: ${({ theme: { colors } }) => colors.background.secondary};
  background-image: url('/static/images/loading-spinner.gif');
  background-repeat: no-repeat;
  background-position: center;
  background-size: 30px;
  z-index: 2;
`;
